
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { ArrowLeft, BarChart3 } from "lucide-react";
import { useTranslation } from "react-i18next";
import NavigationMenu from "@/components/layout/NavigationMenu";
import AnalysisHistory from "./AnalysisHistory";
import type { AIAnalysisResult } from "@/hooks/useAIAnalysis";
// import GeminiTestButton from "@/components/test/GeminiTestButton";

interface EmptyStateProps {
  onBackToHome: () => void;
  onAnalyzeData: () => void;
  onSelectPreviousAnalysis: (analysis: AIAnalysisResult, date: string) => void;
  canAnalyze: boolean;
  isLoading: boolean;
}

const EmptyState = ({ onBackToHome, onAnalyzeData, onSelectPreviousAnalysis, canAnalyze, isLoading }: EmptyStateProps) => {
  const { t } = useTranslation('ai-analysis');
  return (
    <div className="min-h-screen bg-gradient-to-b from-golf-50 to-white">
      <NavigationMenu />
      <div className="container mx-auto p-8">
        <div className="max-w-4xl mx-auto">
          <div className="flex justify-between items-center mb-6">
            <Button
              onClick={onBackToHome}
              variant="outline"
            >
              <ArrowLeft className="h-4 w-4 mr-2" />
              {t('empty.buttons.backToHome')}
            </Button>
            <AnalysisHistory onSelectAnalysis={onSelectPreviousAnalysis} />
          </div>

          <Card className="text-center">
            <CardHeader>
              <CardTitle className="flex items-center justify-center gap-2">
                <BarChart3 className="h-6 w-6 text-golf-600" />
                {t('empty.title')}
              </CardTitle>
            </CardHeader>
            <CardContent className="space-y-4">
              {isLoading ? (
                <p className="text-gray-600">{t('common:loading')}</p>
              ) : (
                <>
                  <p className="text-gray-600">
                    {canAnalyze 
                      ? t('empty.description')
                      : t('empty.limitDescription')
                    }
                  </p>
                  <Button 
                    onClick={onAnalyzeData} 
                    size="lg"
                    disabled={!canAnalyze}
                    className={!canAnalyze ? "opacity-50 cursor-not-allowed" : ""}
                  >
                    {canAnalyze ? t('empty.buttons.analyze') : t('empty.limitReached')}
                  </Button>
                  <p className="text-sm text-gray-500">
                    {t('common:weeklyLimit')}
                  </p>
                </>
              )}
            </CardContent>
          </Card>

          {/* <div className="mt-6 flex justify-center">
            <GeminiTestButton />
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default EmptyState;
